require('./bootstrap');

/**
 * AdminLTE
 */
require('admin-lte/plugins/jquery-validation/jquery.validate');
require('admin-lte/plugins/jquery-validation/additional-methods');
require('admin-lte/plugins/overlayScrollbars/js/OverlayScrollbars');
require('admin-lte');

/**
 * Custom js
 */
require('./main');
